/* Lux desktop drawer accordion (Tsoulfa 2026-07-06).
   Wonder binds its drawer accordion mobile-only (base.js gates the click
   handlers on isMobileMenu), so at desktop a drawer row click navigates.
   At desktop, run the vendor's OWN toggles instead: behavior identical to
   mobile by construction (sibling close, nested cleanup, tabindex flow).
   custom.css reveals on the same .submenu-opened class, drawer-scoped. */
/* The vendor's desktop hover/focus flow (dropdown-opened on rows +
   body.dropdown-open-desk + tabindex churn) serves the masthead; inside the
   drawer it only strands classes (a stranded dropdown-open-desk kept the
   header stuck white). Cut those events off before they reach its rows. */
const luxDrawer = document.querySelector('.wt-drawer--nav.wt-drawer--v5');
if (luxDrawer) {
  for (const t of ['mouseover', 'mouseout', 'focusin', 'focusout']) {
    luxDrawer.addEventListener(t, (e) => {
      if (window.matchMedia('(min-width: 1200px)').matches) e.stopPropagation();
    }, true);
  }
}

document.addEventListener('click', (e) => {
  const link = e.target.closest(
    '.wt-drawer--v5 .wt-page-nav-mega__link--parent, .wt-drawer--v5 .wt-page-nav-mega__sublist__link--parent'
  );
  if (!link) return;
  const mega = link.closest('mega-menu-section');
  if (!mega || typeof mega.isMobileMenu !== 'function' || mega.isMobileMenu()) return; // vendor owns mobile
  if (mega.enableSubmenuLinkInDrawer && e.target.tagName === 'SPAN') return; // mirror vendor: label click navigates
  const toggle = link.classList.contains('wt-page-nav-mega__link--parent')
    ? mega.toggleParentMob
    : mega.toggleSubmenuMob;
  if (typeof toggle !== 'function') return; // fail open: navigate, like before this file existed
  e.preventDefault();
  toggle.call(mega, link);
});

/* Desktop masthead CLICK-TO-OPEN (Tsoulfa 2026-07-07). The vendor opens the
   header dropdowns on hover (base.js: mouseover/focusin -> .dropdown-opened,
   mouseout -> remove after 50ms), so moving the mouse closed the panel and
   people couldn't select. Cut the vendor's hover/focus open on the masthead
   (capture-phase stop, desktop only, like the drawer block above) and drive
   open/close on CLICK: the panel via the vendor's own .dropdown-opened (so
   Σαλόνι's mega opens too), the redesigned two-pane right pane via
   .lux-sub-active. Mobile drawer is a separate subtree and stays hover/tap as
   the vendor built it. The CSS :hover underline is untouched (not a JS event). */
const luxMast = document.querySelector('.wt-header__nav-teaser--full-menu');
if (luxMast) {
  const desk = () => window.matchMedia('(min-width: 1200px)').matches;
  for (const t of ['mouseover', 'mouseout', 'focusin', 'focusout']) {
    luxMast.addEventListener(t, (e) => { if (desk()) e.stopPropagation(); }, true);
  }
  /* Keyboard reachability (Tsoulfa 2026-07-07): the vendor ships every link
     tabindex="-1" and flips them only during its hover/focus churn, which we
     stop at desktop, so the menu was keyboard-dead. Recompute after every state
     change: L1 top links always reachable; L2 + gallery reachable when their
     panel is open; L3 reachable only when its L2 parent is .lux-sub-active (its
     right pane is shown). Mobile keeps the vendor default (all -1). */
  const refreshTab = () => {
    const deskNow = desk();
    luxMast.querySelectorAll('a[data-menu-level]').forEach((a) => {
      let on = false;
      if (deskNow) {
        if (a.getAttribute('data-menu-level') === '1') {
          on = true;
        } else {
          const panel = a.closest('.wt-page-nav-mega__item--parent');
          const open = !!panel && panel.classList.contains('dropdown-opened');
          const nested = a.closest('.wt-page-nav-mega__sublist--nested');
          if (!nested) {
            on = open;
          } else {
            const sub = nested.closest('.wt-page-nav-mega__sublist--parent');
            on = open && !!sub && sub.classList.contains('lux-sub-active');
          }
        }
      }
      a.tabIndex = on ? 0 : -1;
    });
  };
  const closeAll = () => {
    luxMast.querySelectorAll('.wt-page-nav-mega__item--parent.dropdown-opened')
      .forEach((p) => p.classList.remove('dropdown-opened'));
    luxMast.querySelectorAll('.lux-sub-active')
      .forEach((s) => s.classList.remove('lux-sub-active'));
    document.body.classList.remove('dropdown-open-desk');
    refreshTab();
  };
  luxMast.addEventListener('click', (e) => {
    if (!desk()) return;
    const sub = e.target.closest('.wt-page-nav-mega__sublist__link--parent');
    if (sub) {
      const subLi = sub.closest('.wt-page-nav-mega__sublist--parent');
      const panel = sub.closest('.wt-page-nav-mega__item--parent');
      const active = subLi.classList.contains('lux-sub-active');
      e.preventDefault();
      panel.querySelectorAll('.lux-sub-active').forEach((s) => s.classList.remove('lux-sub-active'));
      if (!active) subLi.classList.add('lux-sub-active');
      refreshTab();
      return;
    }
    const cat = e.target.closest('.wt-page-nav-mega__link--parent');
    if (cat) {
      const li = cat.closest('.wt-page-nav-mega__item--parent');
      const open = li.classList.contains('dropdown-opened');
      e.preventDefault();
      closeAll();
      if (!open) {
        li.classList.add('dropdown-opened');
        document.body.classList.add('dropdown-open-desk');
      }
      refreshTab();
    }
  });
  document.addEventListener('click', (e) => {
    if (!desk()) return;
    if (e.target.closest('.wt-header__nav-teaser--full-menu')) return;
    // Outside click while a masthead dropdown is open: close it and SWALLOW the
    // click. The mega scrim is .menu-drawer-overlay, which is ALSO a drawer
    // trigger (base.js triggerQuery), so without this the dismiss-click opened
    // the hamburger drawer. Capture phase runs before the overlay's own handler.
    if (luxMast.querySelector('.wt-page-nav-mega__item--parent.dropdown-opened')) {
      e.stopPropagation();
      e.preventDefault();
      closeAll();
    }
  }, true);
  /* Keyboard (Tsoulfa 2026-07-07): the vendor's masthead keydown handler already
     turns Enter AND Space on a link into a click (and prevents the native
     default, verified), which the click handler above turns into the open /
     sub-activate toggle. Activation is therefore handled; adding our own Space
     handler only double-fired the click and cancelled the toggle. We add only
     what the vendor lacks for click-to-open: Escape closes and returns focus to
     the open top link, and focus leaving the menu (Tab out) closes it, mirroring
     the outside-click dismiss. All desktop-only. */
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape' || !desk()) return;
    const trigger = luxMast.querySelector('.wt-page-nav-mega__item--parent.dropdown-opened > .wt-page-nav-mega__link--parent');
    closeAll();
    if (trigger) trigger.focus();
  });
  document.addEventListener('focusin', (e) => {
    if (!desk() || luxMast.contains(e.target)) return;
    if (luxMast.querySelector('.wt-page-nav-mega__item--parent.dropdown-opened')) closeAll();
  }, true);
  refreshTab();
  window.matchMedia('(min-width: 1200px)').addEventListener('change', refreshTab);
}

/* Homepage installments CTA (Tsoulfa 2026-07-07): «Ξεκίνα την αίτηση» in the
   installments story dead-ended for shoppers with no product (the application
   prefills a plan only from a product-page link, not the cart). Route by cart on
   click: cart >= EUR200 -> the application; under EUR200 or empty -> all products
   (build the order to the instalment floor first). Locale-aware via Shopify.routes.root.
   Scoped to that one CTA, so the phone button and every product-page apply link stay untouched. */
const luxInstallCta = document.querySelector('[id$="__installments_story"] a[href*="aitisi"]');
if (luxInstallCta) {
  luxInstallCta.addEventListener('click', async (e) => {
    e.preventDefault();
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    let total = 0;
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (res.ok) total = (await res.json()).total_price || 0;
    } catch (err) { /* network hiccup: fall through to the shop path */ }
    /* Cart EUR200 guard (Tsoulfa 2026-07-07): instalments need a >= EUR200 basket, the
       same floor as the per-product rule (aa06e33). total_price is the cash total in
       cents; cash >= EUR200 guarantees the regular/instalment total clears it too. Under
       EUR200 (or empty) -> send them to build the order first, never a dead-end apply.
       The aitisi URL is read from the CTA's own href (Liquid already rendered it in the
       page's own locale/translated handle) instead of a hardcoded path, so en/ru/he don't
       risk landing on a mismatched handle. */
    window.location.href = total >= 20000 ? luxInstallCta.getAttribute('href') : (root + 'collections/all');
  });
}
